import { AxiosInstance } from "axios";

export function setupUnauthorizedInterceptor(api: AxiosInstance) {
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      // A API não tem refresh token: um 401 com sessão aberta é token expirado
      // ou revogado, e o único caminho é logar de novo.
      if (
        error.response?.status === 401 &&
        !error.config?.url?.includes("/login") &&
        localStorage.getItem("verden-token")
      ) {
        localStorage.removeItem("verden-token");
        window.location.href = "/auth/login";
      }

      return Promise.reject(error);
    },
  );
}
